import DistribuidorService from "@/services/DistribuidorService";

export const distribuidor = {
  namespaced: true,
  state: {
    distribuidor: {},
  },
  actions: {
    getDistribuidor({ commit }, payload) {
      return DistribuidorService.GetDistribuidor(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postDistribuidor({ commit }, payload) {
      return DistribuidorService.PostDistribuidor(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putDistribuidor({ commit }, payload) {
      return DistribuidorService.PutDistribuidor(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteDistribuidor({ commit }, payload) {
      return DistribuidorService.DeleteDistribuidor(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getDistribuidorOData({ commit }, payload) {
      return DistribuidorService.GetDistribuidorOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default distribuidor;
